<template>
<div class="pt-0 ptHeader mainBackVaillant widthFull mb-5">
  <loading v-if="loadingState" />
  <div class="container ">

    <!--   HEADER TITLE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <div class="row justify-content-center text-left">
      <div class="col-md-12 pb-0">
        <h3 class="Regular text-left h0 widthFull"><b>Gestione Preventivi</b></h3>
      </div>
    </div>

    <div v-if="!presentPractices" class="row justify-content-center pb-5 pt-4 mt-md-5 vaillantCont">
      <h4 class="black center widthFull mt-4">Non hai Preventivi</h4>
      <router-link class="btn btn-primary btn-lg btnYellow mt-2" to="/calcolatore">Crea Preventivo</router-link>
    </div>

    <div v-if="presentPractices" class="row justify-content-center pb-3 pt-md-3 align-items-end">
      <div class="col-md-4 pb-0">
        <h5 class="grey pt-0 pb-0">Totale Preventivi: <b class="black"> {{ counts.countPractices }}</b></h5>
        <h5 class="grey pt-0 mt-2">Totale Fatt. quota Clienti: <b class="black">€ {{ counts.countCashClient | formatNumber }}</b></h5>
        <h5 class="grey pt-0 mt-2">Totale Fatt. quota Cessione: <b class="black">€ {{ counts.countCashInst | formatNumber }}</b></h5>
      </div>
      <div class="col-10 col-md-4 center pl-5 pr-5">
        <VueSvgGauge v-if="counts.countCashInst" :start-angle="-90" :end-angle="90" :value="parseFloat(counts.countCashInst)" :separator-step="step" :min="0" :innerRadius="70" :separatorThickness="1" :max="maxTotCash"
          :gauge-color="[{ offset: 0, color: '#f39324'}, { offset: 100, color: '#00897e'}]" :scale-interval="100">

          <div class="gaugeText">
            <p class="widhtFull pt-5 mt-2"> € </p>
            <p class="widhtFull "> <b>{{counts.countCashInst | formatNumber}}</b> </p>
            <p class="widhtFull "> <small>Totale Fatt. quota Cessione</small></p>
          </div>
        </VueSvgGauge>
      </div>
      <div class="col-md-4">

        <form v-on:submit.prevent="searchBy('text',filterVal)">
          <h5 class="text-center grey mobSearchT">Ricerca Preventivo</h5>
          <div class="input-group mb-0">
            <input type="text" v-model="filterVal" class="form-control seachMobButton" placeholder="Numero Preventivo o Cognome .....">
            <div class="input-group-append ">
              <button class="btn btn-outline-secondary btnYellow" v-on:click="searchBy('text',filterVal)" type="button"> <font-awesome-icon class="white" icon="search" size="sm" /> </button>
            </div>
          </div>
        </form>

        <button v-on:click="searchBy('status','9')" class="btn btn-danger mt-2" style="width: 68%;">
          <font-awesome-icon icon="trash-alt" class="white" size="sm" />  Preventivi Archiviati <b class="ml-3"> {{ counts.hasRemovedPractics }} </b>
        </button>
        <button v-on:click="searchBy('','')" class="btn btn-secondary btnYellow mt-2" style="width: 28%;">
           Reset
        </button>

      </div>
    </div>

    <div class="row justify-content-center pb-5 ">

      <!-- PAGINATION -->
      <div class="col-12 col-md-12 pr-md-5 pl-md-5 center mt-5 pt-4 paginator">
        <pagination v-if="loaded" :options="{theme: 'bootstrap4', texts: { count: 'Visualizzazione da {from} a {to} di {count} Preventivi|{count} Preventivi|Un Preventivo' }}" :records="practicesFiltredCount" v-model="page" :per-page="displayPerPage" @paginate="callback">
        </pagination>
      </div>
      <!-- END -->


      <div v-if="!showFilterText" class="col-md-12 col-lg-12">
        <badger-accordion class="pb-5 mt-4" key="1231dsdfh32354134" :icons="{opened: '<span></span>', closed: '<span></span>'}">

          <badger-accordion-item v-for="(item, key) in practicesFiltred" :key="item.code + '_' + countloop" class="" v-if="item.status != 9" >
            <template slot="header" class="center">
              <div class="row justify-content-center">

                <div class="col-md-9">
                  <h5 class="black">Cessionario Finale:
                    <b v-if="item.flow == 'poste'"> Poste Italiane </b>
                    <b v-if="item.flow == 'cdp'"> Cassa Depositi e Prestiti </b>
                    <b v-if="item.flow == 'general'"> Flusso Base </b>
                    <b v-if="item.flow == 'agileenergy'"> Flusso Agile Energy </b>
                    <b v-if="item.flow == 'mbfacta'"> Flusso MBFACTA </b>
                    <b v-if="item.flow == 'mbfacta_recovery'"> Flusso Personalizzato </b>
                  </h5>
                  <h5 class="black csLineHeight2">
                    Preventivo N. <b class="underline">{{ item.code }}</b>
                    del {{ moment(item.created_at).format('DD-MM-YYYY HH:mm') }} ( {{item.bonus}} )
                    <br/> Cliente: <b> {{ item.client_lastname }} {{item.client_name}}  </b>
                    <br/> Indirizzo dell'immobile: <b> {{item.building_address}} {{item.building_civic}} {{item.building_city}} ({{item.building_province}}) CAP {{item.building_zip}}  </b>

                    <template v-if="item.flow != 'agileenergy'">
                      <p class="pt-2"> <span > Totale Fatturato quota Cliente: <b class="black">€ {{ item.total_transfer_for_client | formatNumber }}</b> </span>
                      <br/> Totale Fatturato quota Cessione: <b class="black">€ {{ item.total_bonus_savings | formatNumber }}</b></p>
                    </template>

                    <template v-else>
                       <p class="pt-2"> <span >
                         <br/>Totale Fattura da installatore professionista in subappalto verso AGILE ENERGY
                         <br/>per il materiale e l'installazione, come indicati nel Preventivo: <b class="green">€ {{ item.totale_imponibile | formatNumber }}*</b> </span>
                        <br/><small>* Da fatturare <b>senza IVA </b> in quanto operazione soggetta al reverse charge art. 17, comma 6, lett. a-ter DPR 633/1972.

                        </small>

                      <br/>
                      <br/> Costo di gestione del Servizio del General Contractor AGILE ENERGY
                      <br/>a supporto della gestione di questa Pratica è pari a:
                      <b class="green">€ {{ item.price_agile | formatNumber }} + IVA (22%)</b>

                      <br/>che sarà fatturato da AGILE ENERGY verso l'installatore professionista in subappalto


                    </p>

                      <!--
                      <template v-if="item.state_agile == 1">
                        <p class="pt-1 green"><b> <small >
                         Questo Preventivo è solo ad uso interno. Controlla che tutto sia corretto
                         e clicca su "INVIA IN VERIFICA" per l'approvazione da parte di Agile Energy.
                         A seguito dell'approvazione ti verrà inviata la <b>Lettera di Affidamento</b>
                         mentre al Committente verrà inviato il <b>Contratto per la fornitura e l’installazione</b>
                         all'indirizzo e-mail <b class="black">"{{ item.client_email }}"</b>

                        </small></b></p>
                      </template>

                      <template v-if="item.state_agile == 2">
                        <p class="pt-1 green"> <b><small >
                         Il tuo Preventivo è in Verifica da AGILE ENERGY. A seguito dell'approvazione da parte di AGILE ENERGY ti verrà inviata la <b>Lettera di Affidamento</b>,
                         mentre al Committente verrà inviato il <b>Contratto per la fornitura e l’installazione</b> all'indirizzo e-mail <b class="black">"{{ item.client_email }}"</b>

                       </small></b></p>
                      </template>

                    -->

                      <template v-if="item.state_agile == 4">
                        <p class="pt-1 green"> <b><small >
                          La Lettera di Affidamento ed il Contratto per la fornitura e l’installazione sono in verifica da AGILE ENERGY.
                          A seguito dell'approvazione <b> verranno inviate al Committente le indicazioni per procedere al pagamento della quota parte relativa alla voce “Totale altri Oneri per il Committente”

                            all'indirizzo e-mail <b class="black">"{{ item.client_email }}"</b>
                          </b>.
                       </small></b></p>
                      </template>

                    </template>


                  </h5>

                  <!--
                    <a class="btn btn-primary m-2 btn-sm" :href="item.invoice_quotation_pdf" target="_blank">
                      <font-awesome-icon icon="eye" size="sm" /> visualizza
                    </a>
                  -->

                  <template v-if="item.flow == 'poste' && flow_poste_active" >

                    <a  class="btn btn-primary btnBlue m-2 btn-sm" :href="item.invoice_quotation_pdf" target="_blank">
                      <font-awesome-icon icon="print" size="sm" /> Visualizza/Stampa/Scarica
                    </a>
                    <!--
                    <router-link :to="{ name: 'acceptInvoice', params: {item: item}}" class="btn btn-primary btn-green m-2 btn-sm">
                      <font-awesome-icon icon="clipboard-check" size="1x" />
                      Conferma Preventivo
                    </router-link>
                    -->

                    <router-link :to="{ name: 'editInvoice', params: {item: item}}" class="btn btn-primary btnYellow m-2 btn-sm">
                      <font-awesome-icon icon="edit" size="1x" />
                      Modifica Preventivo
                    </router-link>

                  </template>

                  <template v-if="item.flow == 'poste' && !flow_poste_active" >
                    <!--
                    <a  class="btn btn-primary btnYellow m-2 btn-sm white " disabled v-html="poste_not_active_text">  </a>
                    -->
                    <h5 class="red Bold">Valore nominale di Cessione modificabile liberalmente dall'aderente ( cliccando "Modifica Preventivo" )
                    </h5>

                    <a  class="btn btn-primary btnBlue m-2 btn-sm" :href="item.invoice_quotation_pdf" target="_blank">
                      <font-awesome-icon icon="print" size="sm" /> Visualizza/Stampa/Scarica
                    </a>

                    <router-link :to="{ name: 'editInvoice', params: {item: item}}" class="btn btn-primary btnYellow m-2 btn-sm">
                      <font-awesome-icon icon="edit" size="1x" />
                      Modifica Preventivo
                    </router-link>

                  </template>



                  <template v-if="item.flow == 'cdp' && flow_cdp_active" >

                    <a  class="btn btn-primary btnBlue m-2 btn-sm" :href="item.invoice_quotation_pdf" target="_blank">
                      <font-awesome-icon icon="print" size="sm" /> Visualizza/Stampa/Scarica
                    </a>

                    <router-link :to="{ name: 'acceptInvoice', params: {item: item}}" class="btn btn-primary btn-green m-2 btn-sm">
                      <font-awesome-icon icon="clipboard-check" size="1x" />
                      Conferma Preventivo
                    </router-link>

                    <router-link :to="{ name: 'editInvoice', params: {item: item}}" class="btn btn-primary btnYellow m-2 btn-sm">
                      <font-awesome-icon icon="edit" size="1x" />
                      Modifica Preventivo
                    </router-link>

                  </template>

                  <template v-if="item.flow == 'cdp' && !flow_cdp_active" >
                    <!-- <a  class="btn btn-primary btnYellow m-2 btn-sm white "  disabled v-html="cdp_not_active_text">  </a> -->

                    <h5 class="red Bold">Valore nominale di Cessione modificabile liberalmente dall'aderente ( cliccando "Modifica Preventivo" )
                    </h5>

                    <a  class="btn btn-primary btnBlue m-2 btn-sm" :href="item.invoice_quotation_pdf" target="_blank">
                      <font-awesome-icon icon="print" size="sm" /> Visualizza/Stampa/Scarica
                    </a>

                    <router-link :to="{ name: 'editInvoice', params: {item: item}}" class="btn btn-primary btnYellow m-2 btn-sm">
                    <font-awesome-icon icon="edit" size="1x" />
                    Modifica Preventivo
                  </router-link>

                    <br/>



                  </template>


                  <template v-if="item.flow == 'general'" >

                    <h5 class="red Bold">Valore nominale di Cessione modificabile liberalmente dall'aderente ( cliccando "Modifica Preventivo" )
                    </h5>

                    <a  class="btn btn-primary btnBlue m-2 btn-sm" :href="item.invoice_quotation_pdf" target="_blank">
                      <font-awesome-icon icon="print" size="sm" /> Visualizza/Stampa/Scarica
                    </a>

                    <router-link :to="{ name: 'acceptInvoice', params: {item: item}}" class="btn btn-primary btn-green m-2 btn-sm">
                      <font-awesome-icon icon="clipboard-check" size="1x" />
                      Conferma Preventivo
                    </router-link>

                    <router-link :to="{ name: 'editInvoice', params: {item: item}}" class="btn btn-primary btnYellow m-2 btn-sm">
                      <font-awesome-icon icon="edit" size="1x" />
                      Modifica Preventivo
                    </router-link>

                  </template>

                  <template v-if="item.flow == 'mbfacta'" >

                    <a  class="btn btn-primary btnBlue m-2 btn-sm" :href="item.invoice_quotation_pdf" target="_blank">
                      <font-awesome-icon icon="print" size="sm" /> Visualizza/Stampa/Scarica
                    </a>
                    <!--
                    <router-link :to="{ name: 'acceptInvoice', params: {item: item}}" class="btn btn-primary btn-green m-2 btn-sm">
                      <font-awesome-icon icon="clipboard-check" size="1x" />
                      Conferma Preventivo
                    </router-link>

                    <router-link :to="{ name: 'editInvoice', params: {item: item}}" class="btn btn-primary btnYellow m-2 btn-sm">
                      <font-awesome-icon icon="edit" size="1x" />
                      Modifica Preventivo
                    </router-link>
                  -->
                  </template>

                  <template v-if="item.flow == 'mbfacta_recovery'" >

                    <a  class="btn btn-primary btnBlue m-2 btn-sm" :href="item.invoice_quotation_pdf" target="_blank">
                      <font-awesome-icon icon="print" size="sm" /> Visualizza/Stampa/Scarica
                    </a>
                      <!--
                    <router-link :to="{ name: 'acceptInvoice', params: {item: item}}" class="btn btn-primary btn-green m-2 btn-sm">
                      <font-awesome-icon icon="clipboard-check" size="1x" />
                      Conferma Preventivo
                    </router-link>

                    <router-link :to="{ name: 'editInvoice', params: {item: item}}" class="btn btn-primary btnYellow m-2 btn-sm">
                      <font-awesome-icon icon="edit" size="1x" />
                      Modifica Preventivo
                    </router-link>
                  -->
                  </template>

                  <template v-if="item.flow == 'agileenergy'" >

                    <a  class="btn btn-primary btnBlue m-2 btn-sm" :href="item.invoice_quotation_pdf" target="_blank">
                      <font-awesome-icon icon="print" size="sm" /> Visualizza/Stampa/Scarica
                    </a>

                    <!--
                    <button v-if="item.state_agile == 1" v-on:click.prevent="sendOfferToVerificationAgileEnergy(item)" class="btn btn-primary btn-green m-2 btn-sm">
                      <font-awesome-icon icon="clipboard-check" size="1x" />
                      INVIA IN VERIFICA
                    </button>
                  -->
                    <router-link v-if="item.state_agile == 3" :to="{ name: 'acceptInvoice', params: {item: item}}" class="btn btn-primary btn-green m-2 btn-sm">
                      <font-awesome-icon icon="clipboard-check" size="1x" />
                      Conferma Preventivo
                    </router-link>

                    <!--
                    <router-link v-if="item.state_agile == 1 || item.state_agile == 9" :to="{ name: 'editInvoice', params: {item: item}}" class="btn btn-primary btnYellow m-2 btn-sm">
                      <font-awesome-icon icon="edit" size="1x" />
                      Modifica Preventivo
                    </router-link>
                    -->

                  </template>


                  <a class="btn btn-danger m-2 btn-sm mr-md-5 " v-on:click.prevent="removeOrder(item.id,item.code,key)">
                    <font-awesome-icon icon="archive" size="sm" /> Annulla ed Archivia Preventivo
                  </a>

                </div>
                <div class="col-7 col-md-1 center pl-md-0 pr-md-0 pt-3 ">
                  <img v-if="item.enea_request == '1'" class="img-fluid widthFull mt-2"  src="../../assets/images/enea.png">
                  <img v-if="item.to_get_cadastral_data == '1'" class="img-fluid widthFull mt-2" src="../../assets/images/dcast.png">
                </div>
                <div class="col-md-2">

                  <span v-if="item.flow != 'agileenergy'" class="inline-block center relative mt-3">
                    <img class="qrcodeImg mb-3" :src="item.qrcode">
                    <br /><small class="qrcodeText mt-3 pt-4"><b>Conferma con QRCode</b></small>
                  </span>



                </div>

                <div v-if="item.error_agile != null && item.flow == 'agileenergy'" class="col-11 col-md-11 mt-3 center requiredCont">
                  <h5 class="black widthFull text-left">
                    <b class="widthFull mr-4"><span class="red"> Attenzione </span> abbiamo rilevato le seguenti anomalie:</b>
                  </h5>

                  <h5 class="red widthFull text-left pl-4">
                    {{ item.error_agile }}
                  </h5>

                </div>


              </div>

            </template>
            <template v-if="3==4" slot="content" class="bbaLightColor">
              <div class="row justify-content-center pb-2 pl-md-3 pr-md-3">

                <div class="col-md-12 col-lg-12">
                  <h5 class="black"> <b>Indirizzo dell'immobile</b></h5>
                </div>


                <div class="col-md-12 col-lg-12 pt-4 pb-3">
                  <h5 class=" pt-0 mt-2">Totale Fatt. quota Cliente: <b class="black">€ {{ item.total_transfer_for_client | formatNumber }}</b></h5>
                  <h5 class=" pt-0 mt-2">Totale Fatt. quota Cessione: <b class="black">€ {{ item.total_bonus_savings | formatNumber }}</b></h5>
                </div>
                <!--
                <div class="col-md-12 col-lg-12">
                  <h5 class="black pb-0"> <b>Dati dell'intervento</b></h5>
                </div>
                <div class="col-md-6">
                  Tipo: <span class="uppercase">{{item.intervention_type}}</span>
                </div>

                <div class="col-md-6">
                  Data: <span class="uppercase">{{moment(item.intervention_date).format('DD-MM-YYYY')}}</span>
                </div>
              -->

              </div>

            </template>
          </badger-accordion-item>


        </badger-accordion>

        <div v-if="hasRemovedPractics">
        <!--
        <badger-accordion class="pb-5 mt-4 " key="1231243412512354134">
          <badger-accordion-item class="" :id="'id_closed'" v-if="hasRemovedPractics">
            <template slot="header" class="center"> -->
              <h5 v-if="hasRemovedPractics" class="text-left black">Preventivi Archiviati</h5>
              <p v-if="hasRemovedPractics" class="text-left black Bold">Attenzione! I dati contenuti in questa schermata non includono i Preventivi archiviati. </p>
          <!--  </template>
            <template slot="content" class="bbaLightColor"> -->


              <badger-accordion class="pb-5 mt-4 greyBg">

                <badger-accordion-item v-for="(item, key) in practicesFiltred" class="" :id="'id' + item.code" :key="item.code + '_r_' + countloop" v-if="item.status == 9 && filter == ''">
                  <template slot="header" class="center">
                    <div class="row justify-content-center">

                      <div class="col-md-9">
                        <h5 class="black">
                          Preventivo N. <b class="underline">{{ item.code }}</b>
                          del {{ moment(item.created_at).format('DD-MM-YYYY HH:mm') }} ( {{item.bonus}} )
                          per <b> {{item.client_name}} {{ item.client_lastname }} </b>
                        </h5>
                        <!--
                  <a class="btn btn-primary m-2 btn-sm" :href="item.invoice_quotation_pdf" target="_blank">
                    <font-awesome-icon icon="eye" size="sm" /> visualizza
                  </a>
                -->

                        <a class="btn btn-primary m-2 btn-sm" :href="item.invoice_quotation_pdf" target="_blank">
                          <font-awesome-icon icon="print" size="sm" /> visualizza/stampa/scarica
                        </a>

                        <a class="btn btn-danger m-2 btn-sm mr-md-5" v-on:click.prevent="removeOrder(item.id,item.code,'restore')">
                          <font-awesome-icon icon="trash-restore-alt" size="sm" /> Ripristina
                        </a>

                      </div>
                      <div class="col-md-3">
                        <!--
                  <span class="inline-block center relative mt-3">
                    <img class="qrcodeImg" :src="item.qrcode">
                    <br /><small class="qrcodeText"><b>Conferma con</b></small>
                  </span>

                  <a class="greenLinkAccordion Regular">Dettagli</a>
                -->
                      </div>

                    </div>

                  </template>
                  <template slot="content" class="bbaLightColor">
                    <div class="row justify-content-center pb-2 pl-md-3 pr-md-3">

                      <div class="col-md-12 col-lg-12">
                        <h5 class="black"> <b>Indirizzo dell'immobile</b></h5>
                      </div>
                      <div class="col-md-12 col-lg-12">
                        {{item.building_address}} {{item.building_civic}} {{item.building_city}} ({{item.building_province}}) CAP: {{item.building_zip}}
                      </div>
                      <div class="col-md-12 col-lg-12">
                        <h5 class="black pb-0"> <b>Dati dell'intervento</b></h5>
                      </div>
                      <div class="col-md-6">
                        Tipo: <span class="uppercase">{{item.intervention_type}}</span>
                      </div>
                      <div class="col-md-6">
                        Data: <span class="uppercase">{{moment(item.intervention_date).format('DD-MM-YYYY')}}</span>
                      </div>

                    </div>

                  </template>
                </badger-accordion-item>


              </badger-accordion>
              <!--
            </template>
          </badger-accordion-item>
        </badger-accordion> -->
      </div>
      </div>

      <div v-else class="col-md-12 col-lg-12 vaillantCont mt-4 pt-5 pb-5">
        <h5 class="center">Nessun risultato  {{ ( filterVal != 1 && filterVal != 2 && filterVal != 3 && filterVal != 0 ) ? ' per ' + filterVal : '' }}</h5>
      </div>

      <!-- PAGINATION -->
      <div class="col-12 col-md-12 pr-md-5 pl-md-5 center mt-5 pt-4 paginator">
          <pagination v-if="loaded" :options="{theme: 'bootstrap4', texts: { count: 'Visualizzazione da {from} a {to} di {count} Preventivi|{count} Preventivi|Un Preventivo' }}" :records="practicesFiltredCount" v-model="page" :per-page="displayPerPage" @paginate="callback">
          </pagination>
      </div>
      <!-- END -->

    </div>

  </div>

</div>
</template>

<script>
import {
  AUTH_REQUEST,
  AUTH_SOCIAL
} from 'actions/auth'
import {
  mapGetters,
  mapState
} from 'vuex'
import axios from 'axios'
import {
  BadgerAccordion,
  BadgerAccordionItem
} from 'vue-badger-accordion'
const moment = require('moment')

import Pagination from 'vue-pagination-2';

import {
  VueSvgGauge
} from 'vue-svg-gauge'

export default {
  name: 'login',
  components: {
    BadgerAccordion,
    BadgerAccordionItem,
    VueSvgGauge,
    Pagination,
  },
  data() {
    return {
      token: '',
      loadingState: false,
      loading: false,
      practices: {},
      countPractices: 0,
      countCashClient: 0,
      countloop: 1,
      countCashInst: 0,
      practicesFiltred: {},
      presentPractices: true,
      moment: require('moment'),
      maxTotCash: 1000000,
      totCash: 0,
      step: 1000,
      showFilterText: false,
      hasRemovedPractics: false,
      brand: process.env.BRAND,

      // NEW PAGINATION
      length: 0,
      filter: '',
      filterVal: '',
      counts: {
        countCashClient: "0",
        countCashInst: "0",
        countErrorPractice: "0",
        countPractices: "0",
        countStep1Practice: "0",
        countStep2Practice: "0",
        countStep3Practice: "0",
        countStep4Practice: "0",
        sumTotal: "0",
        hasRemovedPractics: '0'
      },
      displayPerPage: 10,
      page: 1,
      loaded: false,
      loadedCount: false,
      filterType: false,
      practicesFiltredCount: 0,
      flow_cdp_active: process.env.FLOW_CDP_ACTIVE,
      cdp_not_active_text: process.env.FLOW_CDP_NOT_ACTIVE_TEXT,
      flow_poste_active: process.env.FLOW_POSTE_ACTIVE,
      poste_not_active_text: process.env.FLOW_POSTE_NOT_ACTIVE_TEXT,

    }
  },
  methods: {
    sendOfferToVerificationAgileEnergy(practice){
      //console.warn(practice)
      var _vue = this
      this.loadingState = true

      var token = _vue.getProfile.userToken
      if (token) {
         axios({
            url: process.env.ROOT_API + 'api/sendOfferToVerificationAgileEnergy',
            method: 'POST',
            data: {
              practice: practice,
              userToken: token
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {
            _vue.loadingState = false

            _vue.$swal('Preventivo In Verifica', '', 'success')
            _vue.getPractices()

          })
          .catch(resp => {

            _vue.$swal('Ops. Riprova piu tardi', '', 'error')
            _vue.loadingState = false

          })
      }else{
        _vue.loadingState = false
      }
    },
    async getPractices2() {
      var _vue = this
      this.loadingState = true

      var token = _vue.getProfile.userToken
      if (token) {
        await axios({
            url: process.env.ROOT_API + 'api/getPractices',
            method: 'POST',
            data: {
              type: 0,
              user_token: token
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {

            _vue.practices = resp.data.practices

            _vue.totCash = 0
            _vue.countPractices = 0
            _vue.countCashInst = 0
            _vue.countCashClient = 0
            for (var x in _vue.practices) {
              if (_vue.practices[x].status == '0') {
                // CALC ONLY VALID ORDERS
                _vue.countPractices++
                _vue.totCash = (parseFloat(_vue.totCash) + parseFloat(_vue.practices[x].total_bonus_savings)).toFixed(2)

                _vue.countCashInst = (parseFloat(_vue.countCashInst) + parseFloat(_vue.practices[x].total_bonus_savings)).toFixed(2)
                _vue.countCashClient = (parseFloat(_vue.countCashClient) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2)
              }

              if (_vue.practices[x].status == '9') {
                _vue.hasRemovedPractics = true
              }


            }
            this.totCash = parseFloat(this.totCash)
            if (this.totCash < 10000) {
              this.maxTotCash = 10000
              this.step = 1000
            } else if (this.totCash < 100000) {
              this.maxTotCash = 100000
              this.step = 10000
            } else if (this.totCash < 1000000) {
              this.maxTotCash = 1000000
              this.step = 100000
            } else if (this.totCash < 100000000) {
              this.maxTotCash = 100000000
              this.step = 1000000
            }
            _vue.practicesFiltred = _vue.practices

            _vue.loadingState = false

          })
          .catch(resp => {

            this.presentPractices = false
            _vue.loadingState = false
            //_vue.$swal({
            //  type: 'error',
            //  title: 'Oops...',
            //  text: 'Riprova piu tardi!',
            //});

          })
      }

    },

    searchBy(type, filter){

      this.page = 1
      this.getPractices( type, filter )
      if( filter == '10' || filter == '9' ){
        this.hasRemovedPractics = true
      }else{
        this.hasRemovedPractics = false
      }

    },

    callback: function(page) {
      console.log( 'CHANGE PAGE => To: ' + page )
      this.page = page
      this.getPractices(this.filterType, this.filterVal)

    },

    async getPractices(type , filter) {
      console.log( 'SEARCH BY => ' + type + ' / ' +  filter)
      var _vue = this
      _vue.practicesFiltred = {}

      _vue.showFilterText = false

      if( type && type != '' ){
        this.filterType = type
      }else{
        this.filterType = false
      }

      if( filter && filter != '' ){
        this.filterVal = filter
      }else{
        this.filterVal = ''
      }

      this.loadingState = true
      var token = _vue.getProfile.userToken

      if (token) {
        await axios({
            url: process.env.ROOT_API + 'api/getPracticesPagination',
            method: 'POST',
            data: {
              type: 'orders',
              user_token: token,
              displayPerPage: this.displayPerPage,
              page: this.page,
              filterType: this.filterType,
              filter: this.filterVal
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {
            _vue.practices = resp.data.practices

            if ( _vue.practices.length == 0 ){
              _vue.showFilterText = true
            }

            _vue.practicesFiltred = _vue.practices
            _vue.practicesFiltredCount = parseInt(resp.data.total)

            _vue.loadingState = false
            _vue.loaded = true
          })
          .catch(resp => {
            console.log('errrrrrrrrrrrrrrrrrrrrrrrroooooooooooooooooooooor')
            _vue.presentPractices = false,
            _vue.loadingState = false
            _vue.loaded = true
          })
      }
    },
    getPracticesCounts() {

      var _vue = this

      this.loadingState = true
      var token = _vue.getProfile.userToken

      if (token) {
         axios({
            url: process.env.ROOT_API + 'api/getPracticesCounts',
            method: 'POST',
            data: {
              type: 'orders',
              user_token: token
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {
            console.log( 'COUNT PRACTICES => ' + resp.data.counts )

            _vue.counts = resp.data.counts

            _vue.length = parseInt(_vue.counts.countPractices)

            _vue.totCash = parseFloat(_vue.counts.sumTotal)
            if (_vue.totCash < 10000) {
              _vue.maxTotCash = 10000
              _vue.step = 1000
            } else if (_vue.totCash < 100000) {
              _vue.maxTotCash = 100000
              _vue.step = 10000
            } else if (_vue.totCash < 1000000) {
              _vue.maxTotCash = 1000000
              _vue.step = 100000
            } else if (_vue.totCash < 10000000) {
              _vue.maxTotCash = 10000000
              _vue.step = 1000000
            }

            _vue.loadingState = false

            _vue.loadedCount = true

            _vue.getPractices()

          })
          .catch(resp => {
            console.log('errrrrrrrrrrrrrrrrrrrrrrrroooooooooooooooooooooor')
            _vue.presentPractices = false,
              _vue.loadingState = false
          })
      }
    },

    removeOrder(id, code, key) {
      var id_order = id
      var _vue = this

      if (key == 'restore') {
        var type = 0
        var popUpText = '<br/>Sei sicuro di voler ripristinare Preventivo N. ' + code + '?<br/><br/>'
      } else {
        var type = 9
        var popUpText = '<br/>Sei sicuro di voler archiviare Preventivo N. ' + code + '?<br/><br/>'
      }

      this.$swal({
        title: 'Attenzione!',
        type: 'warning',
        html: popUpText,
        showCancelButton: true,
        confirmButtonText: `SI`,
        cancelButtonText: `NO`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        console.log(result)
        if (result.value) {

          axios({
              url: process.env.ROOT_API + 'api/changeOrderState',
              method: 'POST',
              data: {
                id: id,
                user_token: _vue.getProfile.userToken,
                status: type
              },
              headers: {
                'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
                'Content-type': 'application/json'
              }
            })
            .then(resp => {

              _vue.getPractices()

              if (key == 'restore') {
                _vue.$swal('Preventivo N. ' + code + ' <br/>è stato ripristinato ', '', 'success')
              } else {
                _vue.$swal('Preventivo N. ' + code + ' <br/>è stato archiviato ', '', 'success')
              }

            })
            .catch(resp => {
              _vue.$swal('Ops. Riprova piu tardi', '', 'error')
            })

        }
      })

    },
    showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
      });
    },

  },
  watch: {
    getProfile: function(val) {
      if (val) {
        console.log(val)
        //this.getPractices()
        this.getPracticesCounts()
      }
    },
    filter: function(val) {
      this.filterValues()
    },
  },
  created() {

  },
  mounted() {

    if (this.getProfile) {
      //this.getPractices()
      this.getPracticesCounts()
    }

    this.$scrollTo('#app', 700, {
      offset: -75
    })

  },
  computed: {
    ...mapGetters(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']),
    ...mapState({
      //response: state => `${state.status.response.data}`,
    })
  },
}
</script>
<style lang="scss" scoped>
.badger-toggle-indicator {
    display: none!important;
}
</style>



// WEBPACK FOOTER //
// src/components/offerte/index.vue